// Libs
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import isEmpty from "lodash/isEmpty";

// DLS
import "@collectivehealth/dls-icons/dist/elements/dls-icon-close";

// Components
import RenderIf from "components/RenderIf";

// Styles
import styles from "./Modal.css";

// Constants
export const DATA_HOOK = "Modal";

export default function Modal({
  "data-hook": dataHook = DATA_HOOK,
  body = null,
  className,
  footer = null,
  header = null,
  isOpen = false,
  onClose = null
}) {
  return (
    <div
      className={classNames(styles.root, { [styles.isClosed]: !isOpen }, className)}
      data-hook={dataHook}
    >
      <dls-panel class={styles.panel}>
        <RenderIf test={!isEmpty(header)}>
          <div className={styles.header} slot="panel-head">
            {header}
          </div>
        </RenderIf>

        <section className={styles.body} slot="panel-body">
          {/* Close button lives in body because body is always present and not conditional on having content */}
          <RenderIf test={onClose}>
            <button className={styles.close} type="button" onClick={onClose}>
              <dls-icon-close></dls-icon-close>
            </button>
          </RenderIf>
          {body}
        </section>

        <RenderIf test={!isEmpty(footer)}>
          <footer slot="panel-foot">{footer}</footer>
        </RenderIf>
      </dls-panel>
    </div>
  );
}

Modal.propTypes = {
  "data-hook": PropTypes.string,
  body: PropTypes.node,
  footer: PropTypes.node,
  header: PropTypes.node,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
};
